<div class="modal-container">
  @switch (optionType) {
    @case (MultiSelectType.TAG) {
      <h1 i18n>Edit tag title</h1>
      <h3 i18n>Enter a new title for this tag.</h3>
    }
    @case (MultiSelectType.LABEL) {
      <h1 i18n>Edit label title</h1>
      <h3 i18n>Enter a new title for this label.</h3>
    }
  }
  <input
    name="password"
    id="password"
    type="text"
    [formControl]="titleInput"
    placeholder="Enter your title here"
    i18n-placeholder
    (keyup.enter)="saveOption()" />
  <section class="buttons">
    <button class="close-button" (click)="closeModal()" i18n>Cancel</button>
    <button class="submit-button" i18n (click)="saveOption()">Save</button>
  </section>
</div>
